import React from 'react';

import { useAccount } from '~/apis';
import CountryFlagTooltip from '~/components/CountryFlagTooltip';
import PlayerProfilePicture from '~/components/ProfilePicture/PlayerProfilePicture';
import { useProfileNavigation } from '~/profile/profileNavigation';

export interface UserCellProps {
  name?: string;
  country?: string;
  userId?: string;
}

const UserCell = ({ value }: { value: UserCellProps }) => {
  const { name, country, userId } = value;
  const { data: account } = useAccount();
  const { openUserProfile } = useProfileNavigation();

  const handleUsernameClick = () => {
    if (userId) {
      openUserProfile(userId, account?.userId);
    }
  };

  // Don't make bot usernames clickable
  const isBotUser = userId?.startsWith('bot_') || false;

  return (
    <div className="flex flex-row items-center space-x-4">
      {/* Profile picture with flag badge */}
      <div className="relative shrink-0">
        <PlayerProfilePicture
          userId={userId || ''}
          username={name || ''}
          size="sm"
          className="h-8 w-8"
        />
        {/* Country flag badge at bottom right */}
        {country && (
          <div className="absolute -right-1 -bottom-1 z-20">
            <CountryFlagTooltip countryCode={country} size="md" />
          </div>
        )}
      </div>

      {userId ? (
        <button
          onClick={handleUsernameClick}
          disabled={isBotUser}
          className={`flex-1 text-left transition-colors ${
            isBotUser
              ? 'cursor-default text-gray-500'
              : 'cursor-pointer text-primary hover:text-primary-dark hover:underline'
          }`}
        >
          {name}
        </button>
      ) : (
        <span className="flex-1">{name}</span>
      )}
    </div>
  );
};

export default UserCell;
